import router from '@/router';
import { isElectron } from '@/utils/electronFunc';

/**
 * 根据「路由名称」打开新的窗口
 * @param routeName 路由名称
 * @param query
 * @param params
 */
export function openNewWindow(
  routeName: string,
  query: Record<string, any> = {},
  params: Record<string, any> = {}
): void {
  const options = {
    // 使用resolve
    name: routeName,
    query,
    params,
  };
  if (isElectron()) {
    routerPush(routeName, query, params);
    return;
  }
  const addHref = router.resolve(options);
  window.open(addHref.href, '_blank');
}

/**
 * 根据「路由名称」打开新的标签
 * @param routeName
 * @param query
 * @param params
 */
export function routerPush(
  routeName: string,
  query: Record<string, any> = {},
  params: Record<string, any> = {}
): void {
  router.push({
    name: routeName,
    query,
    params,
  });
}
